import { api, tagTypes } from "./api";

type PaginationParams = {
  page?: number;
  limit?: number;
  search?: string;
};

export const disputeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllDisputes: builder.query<any, PaginationParams>({
      query: ({ page = 1, limit = 10, search = '' }) => ({
        url: `booking/v1/admin/dispute`,
        method: "GET",
        params: { page, limit, search},
      }),
      providesTags: [tagTypes.Booking],
    }),
    getDisputeDetails: builder.query<any, string>({
      query: (bookingId) => ({
        url: `booking/v1/admin/${bookingId}/dispute?admin=1`,
        method: "GET",
      }),
      providesTags: [tagTypes.Booking],
    }),
    refund: builder.mutation<
      any,
      { bookingId: string; amount: number; booking_escrow_trx_id: string }
    >({
      query: ({ bookingId, ...refundData }) => ({
        url: `booking/v1/admin/${bookingId}/dispute/refunds`,
        method: "POST",
        body: refundData,
      }),
      invalidatesTags: [tagTypes.Booking],
    }),
    resolveDispute: builder.mutation<any, { disputeId: string }>({
      query: ({ disputeId }) => ({
        url: `booking/v1/admin/${disputeId}/dispute`,
        method: "POST",
        body: { status: "resolved" },
      }),
      invalidatesTags: [tagTypes.Booking],
    }),
    sendMessage: builder.mutation<
      any,
      { disputeId: string; sender: string; message: string }
    >({
      query: ({ disputeId, ...data }) => ({
        url: `booking/v1/admin/${disputeId}/dispute`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [tagTypes.Booking],
    }),
  }),
});

export const {
  useGetAllDisputesQuery,
  useGetDisputeDetailsQuery,
  useRefundMutation,
  useResolveDisputeMutation,
  useSendMessageMutation,
} = disputeApi;
